
import { required } from 'vuelidate/lib/validators'

export default {
  covenant: {
    // dependent_id: {
    //   required
    // },
    covenant_id: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/covenants/form/resources/validations.js